export function FigmaHowItWorks() {
  return (
    <section className="bg-[#f7f7f7] py-8 md:py-12">
      <div className="container mx-auto px-4 max-w-[1560px]">
        <h2 className="text-[#101828] text-[24px] md:text-[30px] font-bold leading-[30px] md:leading-[36px] text-center mb-2">
          ¿Cómo funciona?
        </h2>
        <p className="text-[#4a5565] text-[14px] md:text-[16px] leading-[20px] md:leading-[24px] text-center mb-[32px] md:mb-[48px] px-4">
          Asegurar tu patinete es muy sencillo e instantáneo, pero es necesario que tengas previamente el registro en la DGT.
        </p>

        <div className="flex flex-col md:flex-row justify-center gap-[24px] md:gap-[32px] max-w-[961px] mx-auto">
          {/* Step 1 */}
          <a 
            href="https://sede.dgt.gob.es/es/vehiculos/matriculaciones-de-vehiculos/inscripcion-vmp/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-center w-full md:w-[277px] block hover:opacity-80 transition-opacity"
          >
            <div className="bg-[#ff6900] rounded-full w-[45px] h-[45px] flex items-center justify-center mx-auto mb-[12px]">
              <span className="text-white text-[24px] font-bold leading-[32px]">1</span>
            </div>
            <h3 className="text-[#101828] text-[18px] font-semibold leading-[27px] mb-2">
              Registra tu patinete en la DGT
            </h3>
            <p className="text-[#4a5565] text-[14px] leading-[20px]">
              Paso obligatorio previo a la contratación
            </p>
          </a>

          {/* Step 2 */}
          <div className="text-center w-full md:w-[277px]">
            <div className="bg-[#ff6900] rounded-full w-[45px] h-[45px] flex items-center justify-center mx-auto mb-[12px]">
              <span className="text-white text-[24px] font-bold leading-[32px]">2</span>
            </div>
            <h3 className="text-[#101828] text-[18px] font-semibold leading-[27px] mb-2">
              Comienza este proceso
            </h3>
            <p className="text-[#4a5565] text-[14px] leading-[20px]">
              Introduce tus datos y la matrícula de tu patinete
            </p>
          </div>

          {/* Step 3 */}
          <div className="text-center w-full md:w-[277px]">
            <div className="bg-[#ff6900] rounded-full w-[45px] h-[45px] flex items-center justify-center mx-auto mb-[12px]">
              <span className="text-white text-[24px] font-bold leading-[32px]">3</span>
            </div>
            <h3 className="text-[#101828] text-[18px] font-semibold leading-[27px] mb-2">
              Realiza el pago
            </h3>
            <p className="text-[#4a5565] text-[14px] leading-[20px]">
              Pago anual por domiciliación o tarjeta
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}